import React, { useEffect } from "react";
import DynamicDatabaseExplorer from "../Comps/Dynamic Report/DynamicDatabaseExplorer.jsx.jsx";
import CustomHeading from "../Comps/Extra/CustomHeading";
import { TbReportSearch } from "react-icons/tb";

const DynamicReport = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div className="newUi text-center m-1 " style={{ minHeight: "90vh" }}>
      <CustomHeading
        text={{
          heading: "Dynamic Reports",
          subText: "Report   Management System",
        }}
        icon={TbReportSearch}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#a5a20c", "#7e8605", "#087331"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",
        }}
      />
      <DynamicDatabaseExplorer
        initialDatabase=""
        initialTable=""
        pageSizeOptions={[25, 50, 100]}
      />
    </div>
  );
};
export default DynamicReport;
